<template>
  <v-card rounded="xl" elevation="3">
    <v-card-title class="font-weight-bold">Monthly Employees</v-card-title>
    <v-divider />
    <v-card-text>
      <apexchart
          height="350"
          type="bar"
          :options="chartOptions"
          :series="series"
      />
    </v-card-text>
  </v-card>
</template>
<script setup>
const employeeData = [
  80,
  190,
  300,
  250,
  420,
  500,
  90,
  150,
  320,
  280,
  450,
  600
]
const series = [
  {
    name: 'Employees',
    data: employeeData
  }
]
/* Dynamic Color Logic */
const dynamicColors = employeeData.map(value => {
  if (value < 100) {
    return '#EF4444' // Red
  }
  if (value >= 100 && value <= 300) {
    return '#F59E0B' // Yellow
  }
  return '#22C55E' // Green
})
const chartOptions = {
  chart: {
    toolbar: {
      show: false
    },
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 1200,
      animateGradually: {
        enabled: true,
        delay: 150
      },
      dynamicAnimation: {
        enabled: true,
        speed: 800
      }
    }
  },

  colors: dynamicColors,
  plotOptions: {
    bar: {
      distributed: true,
      borderRadius: 8,
      columnWidth: '45%'
    }
  },
  dataLabels: {
    enabled: false
  },
  grid: {
    borderColor: '#E2E8F0'
  },
  xaxis: {
    categories: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]
  },
  legend: {
    show: false
  }
}

</script>